export default __webpack_public_path__ + "static/media/univeristeDArtois.ffd39f43.png";